import classNames from "classnames";
// React
import React from "react";
// Components
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./MissingProductInfo.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
const MissingProductInfo = ({ text, isLarge }) => {
    return (React.createElement(FlexContainer, { className: classNames(styles.missingProduct, isLarge && styles.large) },
        React.createElement("span", { className: styles.missingProductIconBackground }),
        React.createElement("span", { className: classNames(styles.missingProductIcon, "glyphicon glyphicon-info-sign") }),
        React.createElement("div", { className: styles.missingProductText }, text)));
};
export default MissingProductInfo;
